import React from "react";
import { createMarkup, isFieldError } from "../../helpers";

const InputUncontrolled = ({
  label,
  note = "",
  reqd,
  name,
  value,
  update,
  errors,
}) => {
  return (
    <div className={isFieldError(errors, name) ? "has-error" : ""}>
      <label htmlFor={name} className="control-label">
        <span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
        {reqd && <span className="reqd">*</span>}
      </label>
      <input
        type="text"
        name={name}
        id={name}
        value={value}
        onChange={(e) => update(name, e.target.value)}
        className={
          isFieldError(errors, name)
            ? "form-control error-border"
            : "form-control"
        }
      />
      <span className={note ? "note" : "hidden"}>{note}</span>
    </div>
  );
};

export default InputUncontrolled;
